module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "halftitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("Shadows made the mountains dark, and you, you didn’t find the way.")])]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—LINE FROM “SYNNØVE’S SONG,” LYRICS BY BJ. BJØRNSON")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e2834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 72
// module chunks = 0